import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { _isTrabzon, _serverUrl2 } from "../../../config";
import { failed } from "../../../Utils/Alerts";
import { tempLayer } from "../../Map/Layers/TempLayer";
import { MyMap } from "../../Map/View/MyMap";

export default function UsersDashboard() {
  const history = useHistory();

  const [info, setInfo] = useState([]);
  const [storeInfo, setStoreInfo] = useState([]);

  const getInfosFromNode = async () => {
    await axios
      .get(_serverUrl2 + "/user/getAllUsers")
      .then((res) => {
        if (res.data.status) {
          setInfo(res.data.rows);
          setStoreInfo(res.data.rows);
        } else {
          failed("Veriler Getirilirken Hata Oluştu. " + res.data.error);
        }
      })
      .catch((err) => {
        failed("Veriler Getirilirken Hata Oluştu. " + err);
      });
  };

  const aramaYap = async () => {
    let item = document.getElementById("arama").value.toLocaleUpperCase("tr-TR");
    setInfo(storeInfo.filter((d) => d.kullanici_adi.toLocaleUpperCase("tr-TR").match(item) || d.isim_soyisim.toLocaleUpperCase("tr-TR").match(item)));
  };

  useEffect(() => {
    getInfosFromNode();
    MyMap.addLayer(tempLayer);
    return () => {
      MyMap.removeLayer(tempLayer);
      tempLayer.getSource().clear();
    };
  }, []);

  return (
    <div className="row">
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content">Kullanıcı Yönetim Paneli</div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="textBox" style={{ fontSize: "12px" }}>
          <div className="row" style={{ padding: "7px" }}>
            <div className="col-sm-8">
              <input id="arama" onChange={() => aramaYap()} placeholder="Ad Soyad veya Kullanıcı Adı ile arama yap" className="form-control form-control-sm" />
            </div>
            {_isTrabzon && (
              <div className="col-sm-4">
                <button className="greenBtn" onClick={() => history.push("/dashboard/users/update/0")}>
                  Yeni Kullanıcı Oluştur{" "}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="col-sm-12">
        <div className="textBox">
          <div className="content">
            <table className="table table-bordered table-striped table-sm" style={{ padding: "10px", fontSize: "12px" }}>
              <tbody>
                <tr>
                  <th>Kullanıcı Adı</th>
                  <th>Ad Soyad</th>
                  <th style={{ width: "100px" }}></th>
                </tr>
                {info.length === 0 ? (
                  <tr>
                    <td colSpan={6} style={{ borderLeft: "3px solid orange" }}>
                      <span>Sonuç Bulunamadı</span>
                    </td>
                  </tr>
                ) : (
                  info.map((datum, index) => {
                    return (
                      <tr key={index}>
                        <td>{datum.kullanici_adi}</td>
                        <td>{datum.isim_soyisim}</td>
                        <td>
                          {datum.rol_kimlik != "Geliştirici" ? (
                            <button className="orangeBtn" onClick={() => history.push("/dashboard/users/update/" + datum.id)} style={{ maxWidth: "100px" }}>
                              Düzenle
                            </button>
                          ) : null}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
